import React, { useState, useEffect, useCallback } from "react";
import { useHistory, useParams, useLocation } from "react-router-dom";
import axios from "../../utils/axios";
import Swal from "sweetalert2";
import { getToken } from "../../utils/Common";
import HEAD from "../../component/header";
import SIDE from "../../component/navbar";
import DataTable from "react-data-table-component";
import Moment from "moment";
import _ from "lodash";

function PurchaseOrder() {
  const token = getToken();
  const headers = {
    Authorization: `Bearer ${token}`,
    "Access-Control-Allow-Origin": "*",
    "Content-Type": "application/json",
  };
  const history = useHistory();
  const FileDownload = require("js-file-download");
  // Session
  const session = localStorage.getItem("user");
  const udeptID = JSON.parse(session).dept_id;
  const hcode = JSON.parse(session).hotel_id;
  const [loading, setLoading] = useState(true);

  // Var
  const [PurchaseOrder, setPurchaseOrder] = useState([]);
  const [hotelList, setHotelList] = useState([]);

  const getListHotelbyUser = async () => {
    try {
      const response = await axios.post(
        `/api/list/hotel/by-user`,
        { hcode },
        { headers }
      );
      setHotelList(response.data);
    } catch (error) {
      console.log("Error API Hotel: ", error);
    }
  };

  const getListPO = async (hotel) => {
    setLoading(true);
    try {
      let hcodeToSend = hotel ? hotel : hcode; // Determine the hcode to send based on the presence of hotel parameter
      const response = await axios.post(
        "/api/waiting/purchase/order",
        { hcode: hcodeToSend, udeptID },
        { headers }
      );
      setPurchaseOrder(Object.values(response.data).flatMap((arr) => arr));
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  const downloadPurchaseorder = () => {
    axios
      .get(
        `/api/generate/excel/report/purchase/order/${hcode}`,
        { responseType: "blob" },
        { headers: headers }
      )
      .then(function (response) {
        // console.log(response.data);
        FileDownload(response.data, "purchase_order.xlsx");
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  // Search
  const [filtertext, setFilterText] = useState("");
  const [resetPaginationToggle, setResetPaginationToggle] = useState(false);

  const filteredItems = PurchaseOrder.filter((search) =>
    Object.values(search)
      .join("")
      .toLowerCase()
      .includes(filtertext.toLowerCase())
  );

  const handleClear = () => {
    if (filtertext) {
      setResetPaginationToggle(!resetPaginationToggle);
      setFilterText("");
    }
  };

  const columns = [
    {
      name: " No.",
      width: "200px",
      cell: (row) => (
        <div>
          <b>PO No: </b> {row.id_po}
          <br />
          <b>PR No</b> : {row.nomer}
        </div>
      ),

      // selector: row => row.nomer,
    },
    {
      name: "Item",
      wrap: true,
      cell: (row) => (
        <div
          style={{
            paddingTop: "10px",
            paddingBottom: "10px",
            color: "#580C30",
          }}
        >
          {row.nama_item}
        </div>
      ),
    },
    {
      name: "Origin",
      wrap: true,
      cell: (row) => (
        <div>
          <b>For Hotel</b> : {row.nm_hotel}
          <br />
          <b>From Department: </b> {row.nm_department}
        </div>
      ),
    },
    {
      name: "Supplier.",
      wrap: true,
      selector: (row) => row.companyname,
    },
    {
      name: "Need",
      cell: (row) => Moment(row.date_need).format("LLL"),
    },
    {
      name: "PO Created",
      cell: (row) => Moment(row.created_at).format("LLL"),
    },
    {
      name: "PO Sent",
      wrap: true,
      cell: (row) => Moment(row.posent).format("LLL"),
    },
    {
      name: "PO File",
      width: "100px",
      cell: (row) => (
        <div>
          {row.file_po && (
            <button
              className="btn btn-dark"
              onClick={() => window.open(row.file_po, "_blank")}
            >
              <i className="bi bi-file-earmark-pdf-fill"></i>
            </button>
          )}
        </div>
      ),
    },
    {
      name: "",
      width: "55px",
      cell: (row) => (
        <>
          <div
            style={{ marginRight: "10px", cursor: "pointer" }}
            onClick={() => history.push(`/detail/proposal/${row.id_pp}`)}
          >
            <i className="bi bi-search"></i>
          </div>
          <div onClick={() => alert(`Reject PO`)}>
            <i className="bi bi-trash"></i>
          </div>
        </>
      ),
    },
  ];

  const customStyles = {
    headCells: {
      style: {
        fontSize: "13px",
      },
    },
    cells: {
      style: {
        fontSize: "11px",
      },
    },
  };

  const debouncedGetListPO = _.debounce(getListPO, 100);
  const debouncedGetListHotelbyUser = _.debounce(getListHotelbyUser, 100);

  // useEffect to trigger debounced functions on mount
  useEffect(() => {
    debouncedGetListPO();
    debouncedGetListHotelbyUser();
  }, []);

  return (
    <>
      <HEAD />
      <SIDE />

      <main id="main" className="main">
        <div className="pagetitle">
          <h6
            className="mb-0"
            style={{ fontWeight: "bold", marginLeft: "7px" }}
          >
            Purchase Order
          </h6>
          <nav>
            <ol className="breadcrumb mt-1 mb-2 ms-2">
              <li
                className="breadcrumb-item"
                style={{ cursor: "pointer", fontSize: "13px" }}
                onClick={() => history.push("/dashboard")}
              >
                Home
              </li>
              <li style={{ fontSize: "13px" }} className="breadcrumb-item">
                Purchase Order
              </li>
              <li
                style={{ fontSize: "13px" }}
                className="breadcrumb-item active"
              >
                List
              </li>
            </ol>
          </nav>
        </div>

        <section>
          <div className="row">
            <div className="col-12">
              <div className="card">
                <div className="card-body">
                  <div className="row p-0 pb-2 mb-2 mt-3">
                    <div className="col-1 pe-0">
                      <button
                        type="button"
                        className="btn btn-sm btn-outline-warning"
                        style={{ marginRight: "12px" }}
                        onClick={() => debouncedGetListPO()}
                      >
                        <i className="bi bi-arrow-clockwise"></i>
                      </button>
                      <button
                        type="button"
                        className="btn btn-sm btn-outline-warning"
                        style={{ marginRight: "1%" }}
                        onClick={() => downloadPurchaseorder()}
                      >
                        <i className="bi bi-printer"></i>
                      </button>
                    </div>

                    <div className="col-7 ps-1">
                      <input
                        type="text"
                        className="form-control form-control-sm"
                        placeholder="Search"
                        onChange={(e) => setFilterText(e.target.value)}
                        onClear={() => handleClear}
                        filtertext={filtertext}
                      />
                    </div>

                    <div className="col-4">
                      <select
                        id="hotelSelect"
                        className="form-select form-select-sm"
                        onChange={(e) => debouncedGetListPO(e.target.value)}
                      >
                        <option>Group By Hotel</option>
                        {hotelList.map((x, t) =>
                          x.map((v, k) => (
                            <option key={k} value={v.id_hotel}>
                              {v.code_hotel} - {v.nm_hotel}
                            </option>
                          ))
                        )}
                      </select>
                    </div>
                  </div>

                  {loading ? (
                    <div
                      className="d-flex flex-column justify-content-center align-items-center"
                      style={{ minHeight: "100px" }}
                    >
                      <div className="spinner-border" role="status">
                        <span className="sr-only"></span>
                      </div>
                      <div style={{ marginTop: "10px" }}>Loading...</div>
                    </div>
                  ) : (
                    <div className="row">
                      <DataTable
                        columns={columns}
                        data={filteredItems}
                        customStyles={customStyles}
                        fixedHeader
                        fixedHeaderScrollHeight="440px"
                        pagination
                      />
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
    </>
  );
}

export default PurchaseOrder;
